module.exports = __webpack_public_path__ + "img/Solomon-Islands.3a15e303.gif";